module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBhVE7ksIwDLUdJ5PCB/AB6DdNqt1+D7D0W1FBwxmoqKCh4gpQUXGFFKlS0sMBkpl8JglPEDMxMEEzHtnyk/SexNiTJUmi4jj+Ym+M9x9RFGnO+aptWwV/CsNwboEJIIT4pUfTNCM4nWXZXCl1QHyHxJT+fN/fSwQWCIxumfzeCMBtlzw2VYuiUIJavqGnnwOEEw8+4Mg+mDSXsiyXnuf9I+kCvzPxqqp0XddrCyylvE0Bh+V5Ph6sjIpHuG94Uv+gBJE0xh8L7DjOGe1ISEpUTBzT0tTNAgM46670GQzSgJAJCcQ1Retjnwa6Liyw67rTboPEP+jRe60MC8wGYS+LIuESXDfI/mMDRqKB218BCBR5rE891/sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/Symbol.png
// module id = 3212
// module chunks = 0